const isDev = process.env.NODE_ENV === "development";

export function devWarn(...args) {
  if (isDev) console.warn(...args);
}

export function devError(...args) {
  if (isDev) console.error(...args);
}

export function storageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    devWarn("ghbb: localStorage read failed", err);
    return null;
  }
}

export function storageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (err) {
    devWarn("ghbb: localStorage write failed", err);
  }
}
